/* tslint:disable */

declare var Object: any;
export interface TeomworklocationServiceInterface {
  "id"?: number;
}

export class TeomworklocationService implements TeomworklocationServiceInterface {
  "id": number;
  constructor(data?: TeomworklocationServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TeomworklocationService`.
   */
  public static getModelName() {
    return "TeomworklocationService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TeomworklocationService for dynamic purposes.
  **/
  public static factory(data: TeomworklocationServiceInterface): TeomworklocationService{
    return new TeomworklocationService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TeomworklocationService',
      plural: 'TeomworklocationServices',
      path: 'TeomworklocationServices',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/TeomworklocationService.ts